import { EntryListPage } from "./EntryListPage";

const FUN_RUN_5K_CATEGORIES = [
  {
    distance: 5,
    displayName: "5 KM",
    description: "FUN RUN 5K CIBODAS",
    categoryName: "FUN RUN 5K CIBODAS",
  },
];

export const FunRun5KEntryListPage = () => (
  <EntryListPage
    eventId="FUNRUN5K2026"
    defaultCollectionName="pendaftaranFunRun5K2026"
    defaultEventTitle="Fun Run 5K Cibodas"
    fallbackCategories={FUN_RUN_5K_CATEGORIES}
    useFirestoreTitle
  />
);
